import DataTable from 'react-data-table-component'
import Modal from 'react-bootstrap/Modal'
import { useEffect, useMemo, useRef, useState } from 'react'
import {
  buildDropdownAudit,
  fetchData,
  fetchFormData,
  findMenuWithParent,
  getEncryptedRoute,
  getTranslatedValue,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../reusable'
import Select from 'react-select'
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers'
import Swal from 'sweetalert2'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import 'react-phone-input-2/lib/bootstrap.css'

import 'react-datepicker/dist/react-datepicker.css'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { ToastContainer } from 'react-toastify'
import { useLoadScript } from '@react-google-maps/api'
import AutoComplete from '../components/AddressAutoComplete'

const gmapLibraries = ['places'] as any
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'
import { useMenuContext } from '../contexts/MenuContext'

const Popup = (props: any) => {
  let t = Tr()
  useLoadScript({ googleMapsApiKey: import.meta.env.VITE_GOOGLE_KEY!, libraries: gmapLibraries })

  // add / edit facility states
  var customer: any = sessionStorage.getItem('admin')
  customer = JSON.parse(customer)
  const [selectedTab, setSelectedTab] = useState(1)
  const [fullName, setFullName] = useState('')
  const [bio, setBio] = useState('')


  const [mobileNumber, setMobileNumber] = useState('')
  const [countryCode, setCountryCode] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [location, setLocation] = useState('')
  const [passwordDisplay, setPasswordDisplay] = useState(false)
  const [error, setError] = useState(Object)
  
  const [image, setImage] = useState()
  const [imageUrl, setImageUrl] = useState('')

  const [coverImage, setCoverImage] = useState<File | null>(null)
  const [coverImageUrl, setCoverImageUrl] = useState<string>('')

  const [longitude, setLongitude] = useState('')
  const [latitude, setLatitude] = useState('')
  const [country, setCountry] = useState('')
  const [state, setState] = useState('')
  const [city, setCity] = useState('')
  const [gender, setGender] = useState('')
  const [age, setAge] = useState('')
  const [language, setLanguage] = useState(null) as any
  const [interestList, setInterestList] = useState([])
  const [selectedInterest, setSelectedInterest] = useState([])
  const [countryList, setCountryList] = useState([])
  const [selectedCountry, setSelectedCountry] = useState(null)
  const [regionList, setRegionList] = useState([])
  const [selectedRegion, setSelectedRegion] = useState(null)
  const [value, setValue] = useState(null)
  var locationreff = useRef(null)
  const [disable, setDisable] = useState(false)
  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/

  // reset password
  const [newPassword, setNewPassword] = useState('')
  const [retypePassword, setRetypePassword] = useState('')
  const [newPasswordDisplay, setNewPasswordDisplay] = useState(false)
  const [retypePasswordDisplay, setRetypePasswordDisplay] = useState(false)
  const [badgesList, setBadgeList] = useState([])
  const [selectedBadge, setSelectedBadge] = useState(null)

  const [levelList] = useState([
    { label: 'Basic', value: 'Basic' },
    { label: 'Silver', value: 'Silver' },
    { label: 'Gold', value: 'Gold' },
    { label: 'Platinum', value: 'Platinum' },
  ])
  const [selectedLevel, setSelectedLevel] = useState(null)

  // old dropdown states for audit
  const [oldSelectedCountry, setOldSelectedCountry] = useState(null) as any
  const [oldSelectedRegion, setOldSelectedRegion] = useState(null) as any
  const [oldSelectedInterest, setOldSelectedInterest] = useState([]) as any
  const [oldSelectedBadge, setOldSelectedBadge] = useState(null) as any
  const [oldSelectedLevel, setOldSelectedLevel] = useState(null) as any
  const [oldLanguage, setOldLanguage] = useState(null) as any

  const getBadgeSystemList = async () => {
    try {
      const response = await fetchData('admin/getbadgesdetaillist', Object, 'GET')
      if (response.status === 200) {

        const simplifiedBadgeList = response.data.map((badge: any) => ({
          value: badge.badgesId,
          label: badge.badges,
        }))


        setBadgeList(simplifiedBadgeList)
      } else {
        toasterrormsg('Failed to fetch data')
      }
    } catch (error) {
      toasterrormsg('Failed to fetch data')
    }

    getLevelSystemList()
  }

  const getLevelSystemList = async () => {
    try {
      const response = await fetchData('admin/getlevelspointlist', Object)
      if (response.status === 200) {
      } else {
        toasterrormsg('Failed to fetch data')
      }
    } catch (error) {
      toasterrormsg('Failed to fetch data')
    }
  }

  useEffect(() => {
    getBadgeSystemList()
    if (props.userId > 0) {
      countryListApiCall()
      interestListApiCall()
      regionListApiCall()
    } else {
      countryListApiCall()
      interestListApiCall()
      regionListApiCall()
    }
  }, [])

  useEffect(() => {
    if (props.userId > 0) {
      userdetail()
    }
  }, [badgesList])

  var languageoption = [
    { value: 'en', label: 'English' },
    { value: 'ru', label: 'Русский' },
    { value: 'uz', label: 'O’zbekcha' },
  ]
  // for split mobile number and country code
  const handleChange = (value: any, country: any, e: any, formate: any) => {
    const parts = formate.split(' ')
    const formattedValue = parts.slice(1).join(' ').replace(/\D/g, '')
    setCountryCode(country.dialCode) // get country code
    setMobileNumber(formattedValue) // get mobile number without country code
  }

  // save user
  const saveUser = async () => {
    setDisable(true)
    var img: any = image
    var coverImg: any = coverImage
    
    let param = new FormData()
    param.append('profile', img)
    param.append('countryCode', countryCode)
    param.append('mobileNumber', mobileNumber)
    param.append('bio', bio)
    param.append('email', email)
    param.append('latitude', latitude)
    param.append('longitude', longitude)
    param.append('location', location)
    param.append('fullName', fullName)
    param.append('gender', gender)
    param.append('age', age)
    if(coverImage){
          param.append('coverImage', coverImg)

    }
    if (password != '' && password != undefined && password != null) {
      param.append('password', password)
    }
    if (selectedBadge && selectedBadge['value']) {
      param.append('badgesId', selectedBadge['value'])
    } else {
    }

    if (selectedLevel && selectedLevel['value']) {
      param.append('level', selectedLevel['value'])
    } else {
    }
    param.append('country', selectedCountry ? selectedCountry : '')
    param.append(
      'region',
      selectedCountry
        ? selectedCountry == '229'
          ? selectedRegion
            ? selectedRegion
            : ''
          : ''
        : ''
    )

    param.append('language', language ? language['value'] : '')
    param.append(
      'interest',
      selectedInterest.length > 0
        ? selectedInterest
          .map((item: any) => {
            return item.value
          })
          .join(',')
        : ''
    )
    param.append(
      'completedSteps',
      JSON.stringify([
        {
          emailRegister: true,
          mobileNumberRegister: true,
          profileDetails: true,
          profilePicture: true,
          interestSelect: true,
          languageSelect: true,
        },
      ])
    )

    if (props.userId > 0) {
      param.append('userId', props.userId)
    }
    param.append('adminId', String(customer?.adminId ?? ''))
    param.append('labels', buildDropdownAudit({
      country: {
        old: countryList.find((c: any) => c.value == oldSelectedCountry) ?? null,
        new: countryList.find((c: any) => c.value == selectedCountry) ?? null,
      },
      region: {
        old: regionList.find((r: any) => r.value == oldSelectedRegion) ?? null,
        new: regionList.find((r: any) => r.value == selectedRegion) ?? null,
      },
      interest: { old: oldSelectedInterest, new: selectedInterest, multi: true },
      badge: { old: oldSelectedBadge, new: selectedBadge },
      level: { old: oldSelectedLevel, new: selectedLevel },
      language: { old: oldLanguage, new: language },
    }))

    var res: any = await fetchFormData('admin/addEditUser', param)
    if (res.status == '200') {
      if (props.userId > 0) {
        toastsuccessmsg('User Updated Successfully')
      } else {
        toastsuccessmsg('User Added Successfully')
      }
      setDisable(false)
      props.onHide()
    } else {
      toasterrormsg(res.message)
      setDisable(false)
    }
  }

  const deleteuser = async (userId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete This User!'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Ok'),
      cancelButtonText: t('Cancel'),
    }).then(async (result) => {
      if (result.isConfirmed) {
        var tmp: any = sessionStorage.getItem('admin')
        tmp = JSON.parse(tmp)

        try {
          var param: any = {
            userId: String(userId),
            deleteBy: tmp['userId'],
            adminId: tmp['adminId'],
          }

          const response = await fetchData('admin/deleteUser', param)

          if (response.status == '200') {
            toastsuccessmsg(response.message)
            props.onHide()
          } else {
            toasterrormsg(response.message)
          }
        } catch (error) {
          toasterrormsg('An error occurred while processing your request.')
        }
      }
    })
  }

  //get user detail
  const userdetail = async () => {
    var param: any = {
      userId: String(props.userId),
    }
    var res = await fetchData('admin/viewUserDetail', param)
    if (res.status == '200') {
      var data = res.data[0]
      setFullName(data['fullName'])
      setEmail(data['email'])
      setMobileNumber(data['mobileNumber'] || '')
      setCountryCode(data['countryCode'])
      setAge(data['age'])
      setBio(data['bio'])      

      setGender(data['gender'])

      
      setLocation(data['location'])
      setLatitude(data['latitude'] ?? '')
      setLongitude(data['longitude'] ?? '')

      if (data.badgesId != null) {
        var selectedBadgeObj: any = badgesList.find((badge: any) => badge.value == data.badgesId)
        setSelectedBadge(selectedBadgeObj || null)
        setOldSelectedBadge(selectedBadgeObj || null)
      }

      // Map level name to level object
      if (data.level != null && data.level.trim() != '') {
        var selectedLevelObj: any = levelList.find((level) => level.value === data.level.trim())
        setSelectedLevel(selectedLevelObj || null)
        setOldSelectedLevel(selectedLevelObj || null)
      }

      var tmpadd: any = { label: data['location'], value: { place_id: '' } }
      setValue(tmpadd)
      setImageUrl(data['profile'])
      setCoverImageUrl(data['coverImage'])

      if (data['language'] != '' && data['language'] != null && data['language'] != undefined) {
        var tmp: any = languageoption.filter((item: any) => item.value == data['language'])

        setLanguage(tmp.length > 0 ? tmp[0] : null)
        setOldLanguage(tmp.length > 0 ? tmp[0] : null)
      } else {
        setLanguage({ value: 'uz', label: "O'zbekcha" })
        setOldLanguage({ value: 'uz', label: "O'zbekcha" })
      }

      setSelectedCountry(data['country'])
      setOldSelectedCountry(data['country'])

      if (data.country == '229') {
        setSelectedRegion(data['region'])
        setOldSelectedRegion(data['region'])
      }

      var tmpintrest: any = await interestListApiCall()
      if (data.interest != undefined && data.interest != null && data.interest != '') {
        var interestarr = data['interest'].split(',')

        var tmp: any = tmpintrest.filter((item: any) => interestarr.includes(String(item.value)))

        setSelectedInterest(tmp)
        setOldSelectedInterest(tmp)
      }
    } else {
      toasterrormsg(res.message)
    }
  }

  // validation
  const validation = async () => {
    var errorMessage = {
      nameError: '',
      mobileError: '',
      emailError: '',
      passwordError: '',
      roleIdError: '',
      locationError: '',
      genderError: '',
      ageError: '',
      languageError: '',
      countryError: '',
      regionError: '',
      interestError: '',
      imageError: '',
      badgeId: '',
      levelId: '',
      coverImageError: '',
      bioError: '',
    }
    var err = 0
    if (fullName === '' || fullName === null || fullName === undefined) {
      errorMessage['nameError'] = t('Full Name Is Required')
      err = 1
    } else if (fullName.length > 100) {
      errorMessage['nameError'] = 'Full Name Is Not Valid'
      err = 1
    }

    if (bio && bio.length < 5) {
      errorMessage['bioError'] = t('Bio is too short. Add a few more words')
      err = 1
    }

    if (mobileNumber === '' || mobileNumber === null || mobileNumber === undefined) {
      errorMessage['mobileError'] = t('Mobile Number Is Required')
      err = 1
    }

    if (!mobileNumber.match(/^\d+$/) || mobileNumber.length > 16 || mobileNumber.length < 6) {
      errorMessage['mobileError'] = t('Mobile Number Is Not Valid')
      err = 1
    }
    if (location == null || location == '' || location == undefined) {
      errorMessage['locationError'] = t('Location Is Required')
      err = 1
    }

    if (selectedBadge == '' || selectedBadge == null || selectedBadge == undefined) {
      errorMessage['badgeId'] = t('Badge Is Required')
      err = 1
    }

    if (selectedLevel == '' || selectedLevel == null || selectedLevel == undefined) {
      errorMessage['levelId'] = t('Level Is Required')
      err = 1
    }

    if (selectedCountry == null || selectedCountry == '' || selectedCountry == undefined) {
      errorMessage['countryError'] = t('Country is Required')
      err = 1
    }
    if (
      selectedCountry != null &&
      selectedCountry != null &&
      selectedCountry != '' &&
      selectedCountry != undefined &&
      selectedCountry == '229' &&
      (selectedRegion == null ||
        selectedRegion == null ||
        selectedRegion == '' ||
        selectedRegion == undefined)
    ) {
      errorMessage['regionError'] = t('Region Is Required')
      err = 1
    }
    if (gender == null || gender == '' || gender == undefined) {
      errorMessage['genderError'] = t('Gender Is Required')
      err = 1
    }
    if (age == null || age == '' || age == undefined) {
      errorMessage['ageError'] = t('Age Is Required')
      err = 1
    } else if (!String(age).match(/^\d+$/) || parseInt(age) <= 0 || parseInt(age) > 100) {
      errorMessage['ageError'] = t('Age Is Not Valid')
      err = 1
    }

    if (language == null || language == '' || language == undefined) {
      errorMessage['languageError'] = t('Language Is Required')
      err = 1
    }

    if (email === '' || email === null || email === undefined) {
      errorMessage['emailError'] = t('Email Is Required')
      err = 1
    }

    if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
      errorMessage['emailError'] = t('Email Is Not Valid.')
      err = 1
    }

    if (props.userId <= 0 && (password === '' || password === null || password === undefined)) {
      errorMessage['passwordError'] = t('Password Is Required')
      err = 1
    } else if (props.userId <= 0 && !passwordRegex.test(password)) {
      errorMessage['passwordError'] = t(
        'Password must be at least 8 characters long and contain at least one alphabet, one number, and one special character'
      )
      err = 1
    }
    if (
      (image == null || image == undefined) &&
      (imageUrl == '' || imageUrl == null || imageUrl == undefined)
    ) {
      errorMessage['imageError'] = t('Profile Picture Is Required')
      err = 1
    }

    if (
      (coverImage == null || coverImage == undefined) &&
      (coverImageUrl == '' || coverImageUrl == null || coverImageUrl == undefined)
    ) {
      errorMessage['coverImageError'] = t('Cover Image Is Required')
      err = 1
    }

    if (selectedInterest.length <= 0) {
      errorMessage['interestError'] = t('Interest Is Required')
      err = 1
    }

    setError(errorMessage)
    if (err == 0) {
      saveUser()
    } else {
    }
  }

  //get country list
  const countryListApiCall = async () => {
    var res = await fetchData('vendor/public/countryList', {})

    if (res.status == '200') {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.countryId, label: val.nicename })
      })

      setCountryList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }

  //get country list
  const interestListApiCall = async () => {
    var param: any = {
      language: '',
    }
    var res = await fetchData('admin/interestlist', param)

    if (res.status == '200') {
      var tmp: any = res.data.map((item: any) => {
        return { value: item.interestId, label: getTranslatedValue(props.lang, item, '_name') }
      })
      setInterestList(tmp)
      return tmp
    } else {
      toasterrormsg(res.message)
    }
  }

  //get country list
  const regionListApiCall = async () => {
    var res = await fetchData('vendor/public/regionList', [])

    if (res.status == '200') {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.regionId, label: getTranslatedValue(props.lang, val, '_name') })
      })

      setRegionList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }

  const handleBadgeChange = (selectedOption: any) => {
    setSelectedBadge(selectedOption)
  }

  const handleLevelChange = (selectedOption: any) => {
    setSelectedLevel(selectedOption)
  }
  ////////////////////// reset password ////////////////////
  // validation
  const resetpasswordvalidation = () => {
    var err = 0
    var tmp: any = {
      newPasswordError: '',
      retypePasswordError: '',
    }

    if (newPassword == '' || newPassword == null || newPassword == undefined) {
      tmp['newPasswordError'] = t('New Password Is Required')
      err = 1
    } else if (!passwordRegex.test(newPassword)) {
      tmp['newPasswordError'] = t(
        'Password must be at least 8 characters long and contain at least one alphabet, one number, and one special character'
      )
      err = 1
    }

    if (retypePassword == '' || retypePassword == null || retypePassword == undefined) {
      tmp['retypePasswordError'] = t('Confirm Password Is Required')
      err = 1
    } else if (newPassword != retypePassword) {
      tmp['retypePasswordError'] = t("Passwords Don't Match")
      err = 1
    }
    setError(tmp)
    if (err == 0) {
      changepasswordapi()
    } else {
    }
  }
  // change password API call
  const changepasswordapi = async () => {
    setDisable(true)
    const tmpAdmin = sessionStorage.getItem('admin')
    const adminIdVal = tmpAdmin ? JSON.parse(tmpAdmin)?.adminId ?? '' : ''
    var param: any = {
      userId: props.userId,
      newpassword: newPassword,
      adminId: adminIdVal,
    }
    var response: any = await fetchData('admin/userchangepassword', param)
    if (response.status == '200') {
      toastsuccessmsg('Password Changed Successfully')
      setDisable(false)
      props.onHide()
    } else {
      toasterrormsg(response.message)
      setDisable(false)
    }
  }

  // add / edit facility state end
  return (
    <Modal
      {...props}
      size='xl'
      aria-labelledby='contained-modal-title-hcenter'
      dialogClassName='maxwidth1000px'
      centered
      backdrop='static'
      keyboard={false}
    >
      <Modal.Header closeButton>
        <div className='d-flex align-items-center col-10'>
          <h4 className='fw-bold'>
            {props.userId > 0 ? t('Edit') : t('Add')} {t('User')}
          </h4>
        </div>
      </Modal.Header>
      <Modal.Body>
        <style>{`
        #pac-container {
          padding-bottom: 12px;
          margin-right: 12px;
        }
        
        .pac-controls {
          display: inline-block;
          padding: 5px 11px;
        }
        
        .pac-controls label {
          font-family: Roboto;
          font-size: 13px;
          font-weight: 300;
        }
        
        .pac-container {
          z-index: 10000 !important;
        }
        
        #pac-input {
          background-color: #fff;
          font-family: Roboto;
          font-size: 15px;
          font-weight: 300;
          margin-left: 12px;
          padding: 0 11px 0 13px;
          text-overflow: ellipsis;
          width: 400px;
        }
        
        #pac-input:focus {
          border-color: #4d90fe;
        }
      `}</style>
        <div
          className='stepper stepper-links d-flex flex-column'
          id='kt_create_account_stepper'
          data-kt-stepper='true'
        >
          {props.userId > 0 && (
            <div className='stapper d-flex justify-content-center mb-5'>
              <span
                className={`btn me-2 btn-wave waves-effect  ${selectedTab == 1 ? 'waves-light text-white greenbtn' : ''
                  }`}
                title='Edit profile'
                onClick={() => {
                  setSelectedTab(1)
                  setError(Object)
                }}
              >
                {t('Profile Detail')}
              </span>
              <span
                className={`btn me-2 ${selectedTab == 2 ? 'waves-light text-white greenbtn' : ''}`}
                title='Change Password'
                onClick={() => {
                  setSelectedTab(2)
                  setError(Object)
                }}
              >
                {t('Change Password')}
              </span>
              {props.menuIdDelete ? (
                <button
                  className='btn btn-wave waves-effect waves-light btn-primary-light me-2'
                  title='delete'
                  onClick={() => deleteuser(props.userId)}
                >
                  {t('Delete User')}
                </button>
              ) : (
                ''
              )}
            </div>
          )}
          {selectedTab == 1 && (
            <div>
              {/* <!--begin::Input group--> */}
              <div className='row g-5 justify-content-center'>
                {/* Profile Picture - Left Side */}
                <div className='col-lg-6 col-xl-5'>
                  <div className='text-end' id='kt_profile_picture_form'>
                    <label className='col-form-label required fw-bold fs-6 mb-4 d-block'>
                      {t('Profile Picture')}
                    </label>
                    <div>
                      <div className='image-input image-input-outline' data-kt-image-input='true'>
                        <img
                          alt='Profile '
                          id='previewProfileImage'
                          className='image-input-wrapper w-125px h-125px changeimg pointer'
                          src={
                            image
                              ? URL.createObjectURL(image)
                              : imageUrl === undefined || imageUrl === '' || imageUrl === null
                                ? toAbsoluteUrl('/media/default.jpg')
                                : props.url  + imageUrl
                          }
                        />

                        <label
                          className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                          data-kt-image-input-action='change'
                          data-bs-toggle='tooltip'
                          title='Change profile picture'
                          data-bs-original-title='Change profile picture'
                        >
                          <i className='fa fa-edit'></i>
                          <input
                            type='file'
                            name='image'
                            id='profileImage'
                            accept='.png, .jpg, .jpeg'
                            style={{ display: 'none' }}
                            onChange={(e: any) => {
                              if (
                                e.target.files[0]['type'] != 'image/jpeg' &&
                                e.target.files[0]['type'] != 'image/jpg' &&
                                e.target.files[0]['type'] != 'image/png'
                              ) {
                                alert('Upload Only JPG, PNG Or PNG File')
                              } else if (
                                e.target.files[0] != null &&
                                e.target.files[0] != undefined
                              ) {
                                setImage(e.target.files[0])
                              }
                            }}
                          />
                          <input type='hidden' name='avatar_remove' />
                        </label>
                      </div>
                    </div>
                    <div className='form-text' id='validimage'>
                      {t('Allowed file types: png, jpg, jpeg.')}
                    </div>
                    <label className='text-danger'>{error['imageError'] || ''}</label>
                  </div>
                </div>

                {/* Cover Image - Right Side */}
                <div className='col-lg-6'>
                  <div className='mx-auto mw-600px w-100' id='kt_cover_image_form'>
                    <label className='col-form-label required fw-bold fs-6 mb-4'>
                      {t('Cover Image')}
                    </label>
                    <div>
                      <div className='image-input image-input-outline' data-kt-image-input='true'>
                        <img
                          alt='Cover background'
                          id='previewCoverImage'
                          className='image-input-wrapper w-125px h-125px changeimg pointer'
                          src={
                            coverImage
                              ? URL.createObjectURL(coverImage)
                              : coverImageUrl === undefined || coverImageUrl === '' || coverImageUrl === null
                                ? toAbsoluteUrl('/media/default.jpg')
                                : props.url + coverImageUrl
                          }
                        />

                        <label
                          className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                          data-kt-image-input-action='change'
                          data-bs-toggle='tooltip'
                          title='Change cover image'
                          data-bs-original-title='Change cover image'
                        >
                          <i className='fa fa-edit'></i>
                          <input
                            type='file'
                            name='coverImage'
                            id='coverImageInput'
                            accept='.png, .jpg, .jpeg'
                            style={{ display: 'none' }}
                            onChange={(e: any) => {
                              if (
                                e.target.files[0]['type'] != 'image/jpeg' &&
                                e.target.files[0]['type'] != 'image/jpg' &&
                                e.target.files[0]['type'] != 'image/png'
                              ) {
                                alert('Upload Only JPG, PNG Or PNG File')
                              } else if (
                                e.target.files[0] != null &&
                                e.target.files[0] != undefined
                              ) {
                                setCoverImage(e.target.files[0])
                              }
                            }}
                          />
                          <input type='hidden' name='cover_remove' />
                        </label>
                      </div>
                    </div>
                    <div className='form-text' id='validCoverImage'>
                      {t('Allowed file types: png, jpg, jpeg.')}
                    </div>
                    <label className='text-danger'>{error['coverImageError'] || ''}</label>
                  </div>
                </div>
              </div>

              {/* <!--end::Input group--> */}

              <div className='mx-auto mw-600px w-100 py-5' id='kt_create_account_form'>
                <div>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                    {t('Full Name')}
                  </label>
                  <input
                    type='text'
                    name='rolename'
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    placeholder={t('Full Name')}
                    value={fullName}
                    onChange={(e: any) => setFullName(e.target.value)}
                  ></input>
                  <label className='text-danger'>{error['nameError'] || ''}</label>
                </div>

                <div>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                    {t('Email')}
                  </label>
                  <input
                    type='text'
                    name='rolename'
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    placeholder={t('Email')}
                    value={email}
                    onChange={(e: any) => setEmail(e.target.value)}
                  ></input>
                  <label className='text-danger'>{error['emailError'] || ''}</label>
                </div>

                <div>
                  <label className='form-label fw-bolder text-dark fs-6 required'>
                    {t('Mobile Number')}
                  </label>
                  <PhoneInput
                    inputClass='form-control form-control-solid w-100'
                    placeholder={t('Enter Mobile Number')}
                    enableSearch={true}
                    value={countryCode + mobileNumber}
                    onChange={handleChange}
                  />
                  <label className='text-danger w-100'>{error['mobileError'] || ''}</label>
                </div>

                <div>
                  <label className='form-label fw-bolder text-dark fs-6 required'>
                    {t('Select Badge')}
                  </label>

                  <Select
                    className='me-3'
                    options={badgesList}
                    placeholder={t('Select Badge')}
                    isSearchable={true}
                    value={selectedBadge}
                    onChange={handleBadgeChange}
                  />
                  <label className='text-danger w-100'>{error['badgeId'] || ''}</label>
                </div>

                <div>
                  <label className='form-label fw-bolder text-dark fs-6 mt-5 required'>
                    {t('Select Level')}
                  </label>

                  <Select
                    className='me-3'
                    options={levelList}
                    placeholder={t('Select Level')}
                    isSearchable={true}
                    value={selectedLevel}
                    onChange={handleLevelChange}
                  />
                  <label className='text-danger w-100'>{error['levelId'] || ''}</label>
                </div>

                <div>
                  <label className='form-label required fw-bolder text-dark fs-6 mt-5'>
                    {t('Location')}
                  </label>

                  <AutoComplete
                    name='location'
                    id='location'
                    placeholder={t('Enter Location')}
                    value={location}
                    onAddressSelect={(location: any) => {
                      setLocation(location)
                    }}
                    longitude={(lng: any) => setLongitude(lng)}
                    latitude={(lat: any) => setLatitude(lat)}
                    country={(cnt: any) => setCountry(cnt)}
                    state={(st: any) => setState(st)}
                    city={(ct: any) => setCity(ct)}
                  />

                  <label className='text-danger w-100'>{error['locationError'] || ''}</label>
                </div>

                <div>
                  <label className='form-label fw-bolder required text-dark fs-6'>
                    {t('Interest')}
                  </label>

                  <Select
                    className='mb-3 mb-lg-0'
                    options={interestList}
                    placeholder={t('Select Interest')}
                    value={selectedInterest}
                    isMulti={true}
                    onChange={(e: any) => {
                      setSelectedInterest(e)
                    }}
                  />

                  <label className='text-danger w-100'>{error['interestError'] || ''}</label>
                </div>

                <div>
                  <label className='required  form-label fw-bolder text-dark fs-6'>
                    {t('Country')}
                  </label>

                  <Select
                    className='mb-3 mb-lg-0'
                    options={countryList}
                    value={countryList.find((option: any) => option.value == selectedCountry) || ''}
                    placeholder={t('Select Country')}
                    onChange={(e: any) => {
                      setSelectedCountry(e.value)
                    }}
                  />

                  <label className='text-danger w-100'>{error['countryError'] || ''}</label>
                </div>

                {selectedCountry && selectedCountry == '229' && (
                  <div>
                    <label className='required form-label fw-bolder text-dark fs-6'>
                      {t('Region')}
                    </label>

                    <Select
                      className='mb-3 mb-lg-0'
                      options={regionList}
                      placeholder={t('Select Region')}
                      value={regionList.find((option: any) => option.value == selectedRegion) || ''}
                      onChange={(e: any) => setSelectedRegion(e.value)}
                    />

                    <label className='text-danger w-100'>{error['regionError'] || ''}</label>
                  </div>
                )}

                <div>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                    {t('Gender')}
                  </label>
                  <label className='form-check form-check-sm form-check-custom form-check-solid mb-3 me-5'>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='gender'
                      checked={gender?.toLowerCase() == 'male' ? true : false}
                      value='MALE'
                      onChange={(e: any) => setGender(e.target.value)}
                    />
                    <span className='form-check-label text-gray-600'>{t('Male')}</span>
                  </label>
                  <label className='form-check form-check-sm form-check-custom form-check-solid mb-3 me-5'>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='gender'
                      checked={gender?.toLowerCase() == 'female' ? true : false}
                      value='FEMALE'
                      onChange={(e: any) => setGender(e.target.value)}
                    />
                    <span className='form-check-label text-gray-600'>{t('Female')}</span>
                  </label>
                  <label className='form-check form-check-sm form-check-custom form-check-solid mb-3 me-5'>
                    <input
                      className='form-check-input'
                      type='radio'
                      name='gender'
                      checked={gender?.toLowerCase() == 'other' ? true : false}
                      value='OTHER'
                      onChange={(e: any) => setGender(e.target.value)}
                    />
                    <span className='form-check-label text-gray-600'>{t('Other')}</span>
                  </label>
                  <label className='text-danger'>{error['genderError'] || ''}</label>
                </div>
                <div>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                    {t('Age')}
                  </label>
                  <input
                    type='text'
                    name='age'
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    placeholder={t('Age')}
                    value={age}
                    onChange={(e: any) => setAge(e.target.value)}
                  ></input>
                  <label className='text-danger'>{error['ageError'] || ''}</label>
                </div>
                <div>
                  <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                    {t('Language')}
                  </label>
                  <Select
                    options={languageoption}
                    placeholder={t('Select Language')}
                    value={language ? language : null}
                    onChange={(e: any) => setLanguage(e)}
                  />
                  <label className='text-danger'>{error['languageError'] || ''}</label>
                </div>
                <div>
                  <label className='col-lg-4 col-form-label  fw-bold fs-6'>
                    {t('Bio')}
                  </label>
                  <textarea
                    placeholder={t('Enter Bio')}
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                    value={bio}
                    onChange={(e: any) => setBio(e.target.value)}
                  ></textarea>
                  <label className='text-danger'>{error['bioError'] || ''}</label>
                </div>
                {props.userId <= 0 && (
                  <div>
                    <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                      {t('Password')}
                    </label>

                    <div
                      className='col-lg-12 fv-row fv-plugins-icon-container'
                      style={{ position: 'relative' }}
                    >
                      <input
                        type={passwordDisplay == false ? 'password' : 'text'}
                        name='password'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder={t('Password')}
                        value={password}
                        onChange={(e: any) => setPassword(e.target.value)}
                      />
                      <span
                        className='cursor-pointer'
                        style={{ position: 'absolute', top: '25%', right: '20px' }}
                        title={passwordDisplay == true ? 'Hide' : 'Show'}
                        onClick={() => setPasswordDisplay(!passwordDisplay)}
                      >
                        <FontAwesomeIcon icon={passwordDisplay == true ? faEyeSlash : faEye} />
                      </span>
                      <div className='fv-plugins-message-container invalid-feedback'></div>
                    </div>
                    <label className='text-danger'>{error['passwordError'] || ''}</label>
                  </div>
                )}

                {/* action button start */}
                <div className={`d-flex pt-15 justify-content-center`}>
                  <button
                    type='button'
                    className={`btn btn-lg btn-light-success me-3`}
                    onClick={props.onHide}
                  >
                    {t('Cancel')}
                  </button>

                  <button
                    type='button'
                    className={`btn btn-lg btn-success monthBtn me-3`}
                    onClick={() => validation()}
                  >
                    <span className='indicator-label'>{t('Save')}</span>
                    <span className='indicator-progress'>
                      {t('Please wait...')}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  </button>
                </div>
                {/* action button end */}
              </div>
            </div>
          )}
          {selectedTab == 2 && (
            <div>
              {/* <!--Begin form --> */}

              <form className='form w-100' id='kt_change_password_form' method='POST'>
                <div className='row mb-6'>
                  {/* <!--begin::Label--> */}
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    <span className='required'>{t('New Password')}</span>
                  </label>
                  {/* <!--end::Label--> */}
                  {/* <!--begin::Col--> */}
                  <div
                    className='col-lg-8 fv-row fv-plugins-icon-container'
                    style={{ position: 'relative' }}
                  >
                    <input
                      type={newPasswordDisplay == false ? 'password' : 'text'}
                      name='newPassword'
                      id='newPassword'
                      className='form-control form-control-lg form-control-solid'
                      placeholder={t('New Password')}
                      value={newPassword}
                      onChange={(e: any) => setNewPassword(e.target.value)}
                    />
                    <span
                      className='cursor-pointer'
                      style={{ position: 'absolute', top: '25%', right: '20px' }}
                      title={newPasswordDisplay == true ? 'Hide' : 'Show'}
                      onClick={() => setNewPasswordDisplay(!newPasswordDisplay)}
                    >
                      <FontAwesomeIcon icon={newPasswordDisplay == true ? faEyeSlash : faEye} />
                    </span>
                    <div className='fv-plugins-message-container invalid-feedback'>
                      {error.newPasswordError || ''}
                    </div>
                  </div>

                  {/* <!--end::Col--> */}
                </div>
                {/* <!--end::Input group--> */}

                {/* <!--begin::Input group--> */}
                <div className='row mb-6'>
                  {/* <!--begin::Label--> */}
                  <label className='col-lg-4 col-form-label fw-bold fs-6'>
                    <span className='required'>{t('Confirm Password')}</span>
                  </label>
                  {/* <!--end::Label--> */}
                  {/* <!--begin::Col--> */}
                  <div
                    className='col-lg-8 fv-row fv-plugins-icon-container'
                    style={{ position: 'relative' }}
                  >
                    <input
                      type={retypePasswordDisplay == false ? 'password' : 'text'}
                      name='confirmPassword'
                      id='confirmPassword'
                      className='form-control form-control-lg form-control-solid'
                      placeholder={t('Confirm Password')}
                      value={retypePassword}
                      onChange={(e: any) => setRetypePassword(e.target.value)}
                    />
                    <span
                      className='cursor-pointer'
                      style={{ position: 'absolute', top: '25%', right: '20px' }}
                      title={retypePasswordDisplay == true ? 'Hide' : 'Show'}
                      onClick={() => setRetypePasswordDisplay(!retypePasswordDisplay)}
                    >
                      <FontAwesomeIcon icon={retypePasswordDisplay == true ? faEyeSlash : faEye} />
                    </span>
                    <div className='fv-plugins-message-container invalid-feedback'>
                      {error.retypePasswordError || ''}
                    </div>
                  </div>

                  {/* <!--end::Col--> */}
                </div>
                {/* <!--end::Input group--> */}

                {/* <!--begin::Actions--> */}
                <div className='card-footer d-flex justify-content-center py-6 px-9'>
                  <button
                    type='button'
                    name='submit'
                    className='btn btn-success monthBtn apac-grad'
                    id=''
                    disabled={disable}
                    onClick={() => resetpasswordvalidation()}
                  >
                    {t('Change Password')}
                  </button>
                </div>
                {/* <!--end::Actions--> */}
              </form>
              {/* <!-- End form --> */}
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal >
  )
}

function UserPage() {
  let t = Tr()
  const {  menuIdAdd, menuIdEdit, menuIdDelete } = useMenuIdPermissions()

          const { fullMenu } = useMenuContext()
    const result = findMenuWithParent(fullMenu, "../postmanagement/");
    const postManagementId = result?.menu?.menuId

  const [showPopup, setShowPopup] = useState(false)
  const [userList, setUserList] = useState([])
  const [orguserList, setorguserList] = useState([])
  const [userId, setUserId] = useState(0)
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState(0)
  const [changePassword, setChangePassword] = useState(false)
  const [url, setUrl] = useState("")
  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/

  const lang = useLang()
  // add edit user

  const ChangePasswordPopup = (props: any) => {
    const [oldPassword, setOldPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [retypePassword, setRetypePassword] = useState('')
    const [oldPasswordDisplay, setOldPasswordDisplay] = useState(false)
    const [newPasswordDisplay, setNewPasswordDisplay] = useState(false)
    const [retypePasswordDisplay, setRetypePasswordDisplay] = useState(false)
    const [disable, setDisable] = useState(false)
    const [error, setError] = useState(Object)

    // validation
    const validation = () => {
      var err = 0
      var tmp: any = {
        newPasswordError: '',
        retypePasswordError: '',
      }

      if (newPassword == '' || newPassword == null || newPassword == undefined) {
        tmp['newPasswordError'] = t('New Password Is Required')
        err = 1
      } else if (!passwordRegex.test(newPassword)) {
        tmp['newPasswordError'] = t(
          'Password must be at least 8 characters long and contain at least one alphabet, one number, and one special character'
        )
        err = 1
      }

      if (retypePassword == '' || retypePassword == null || retypePassword == undefined) {
        tmp['retypePasswordError'] = t('Confirm Password Is Required')
        err = 1
      } else if (newPassword != retypePassword) {
        tmp['retypePasswordError'] = t("Passwords Don't Match")
        err = 1
      }
      setError(tmp)
      if (err == 0) {
        changepasswordapi()
      }
    }
    // change password API call
    const changepasswordapi = async () => {
      const tmpAdmin2 = sessionStorage.getItem('admin')
      const adminIdVal2 = tmpAdmin2 ? JSON.parse(tmpAdmin2)?.adminId ?? '' : ''
      var param: any = {
        userId: props.userId,
        currentpassword: oldPassword,
        newpassword: newPassword,
        adminId: adminIdVal2,
      }

      var response: any = await fetchData('admin/userchangepassword', param)

      if (response.status == '200') {
        toastsuccessmsg('Password Changed Successfully')
        props.onHide()
      } else {
        toasterrormsg(response.message)
      }
    }

    // add / edit facility state end
    return (
      <Modal
        {...props}
        size='xl'
        aria-labelledby='contained-modal-title-hcenter'
        dialogClassName='maxwidth1000px'
        centered
        backdrop='static'
        keyboard={false}
      >
        <Modal.Header closeButton>
          <div className='d-flex align-items-center col-10'>
            <h4 className='fw-bold'>{t('Change Password')}</h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div>
            {/* <!--Begin form --> */}
            <form className='form w-100' id='kt_change_password_form' method='POST'>
              {/* <!--begin::Input group--> */}
              <div className='row mb-6'>
                {/* <!--begin::Label--> */}
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                  {t('Current Password')}
                </label>

                {/* <!--end::Label--> */}
                {/* <!--begin::Col--> */}
                <div className='col-lg-8'>
                  {/* <!--begin::Row--> */}
                  <div className='row'>
                    {/* <!--begin::Col--> */}
                    <div
                      className='col-lg-12 fv-row fv-plugins-icon-container'
                      style={{ position: 'relative' }}
                    >
                      <input
                        type={oldPasswordDisplay == false ? 'password' : 'text'}
                        name='currentPassword'
                        className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                        placeholder={t('Current Password')}
                        value={oldPassword}
                        onChange={(e: any) => setOldPassword(e.target.value)}
                      />
                      <span
                        className='cursor-pointer'
                        style={{ position: 'absolute', top: '25%', right: '20px' }}
                        title={oldPasswordDisplay == true ? 'Hide' : 'Show'}
                        onClick={() => setOldPasswordDisplay(!oldPasswordDisplay)}
                      >
                        <FontAwesomeIcon icon={oldPasswordDisplay == true ? faEyeSlash : faEye} />
                      </span>
                      <div className='fv-plugins-message-container invalid-feedback'>
                        {error.oldPasswordError || ''}
                      </div>
                    </div>

                    {/* <!--end::Col--> */}
                  </div>
                  {/* <!--end::Row--> */}
                </div>
                {/* <!--end::Col--> */}
              </div>
              {/* <!--end::Input group--> */}

              {/* <!--begin::Input group--> */}
              <div className='row mb-6'>
                {/* <!--begin::Label--> */}
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>{t('New Password')}</span>
                </label>
                {/* <!--end::Label--> */}
                {/* <!--begin::Col--> */}
                <div
                  className='col-lg-8 fv-row fv-plugins-icon-container'
                  style={{ position: 'relative' }}
                >
                  <input
                    type={newPasswordDisplay == false ? 'password' : 'text'}
                    name='newPassword'
                    id='newPassword'
                    className='form-control form-control-lg form-control-solid'
                    placeholder={t("'New Password'")}
                    value={newPassword}
                    onChange={(e: any) => setNewPassword(e.target.value)}
                  />
                  <span
                    className='cursor-pointer'
                    style={{ position: 'absolute', top: '25%', right: '20px' }}
                    title={newPasswordDisplay == true ? 'Hide' : 'Show'}
                    onClick={() => setNewPasswordDisplay(!newPasswordDisplay)}
                  >
                    <FontAwesomeIcon icon={newPasswordDisplay == true ? faEyeSlash : faEye} />
                  </span>
                  <div className='fv-plugins-message-container invalid-feedback'>
                    {error.newPasswordError || ''}
                  </div>
                </div>

                {/* <!--end::Col--> */}
              </div>
              {/* <!--end::Input group--> */}

              {/* <!--begin::Input group--> */}
              <div className='row mb-6'>
                {/* <!--begin::Label--> */}
                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                  <span className='required'>{t('Confirm Password')}</span>
                </label>
                {/* <!--end::Label--> */}
                {/* <!--begin::Col--> */}
                <div
                  className='col-lg-8 fv-row fv-plugins-icon-container'
                  style={{ position: 'relative' }}
                >
                  <input
                    type={retypePasswordDisplay == false ? 'password' : 'text'}
                    name='confirmPassword'
                    id='confirmPassword'
                    className='form-control form-control-lg form-control-solid'
                    placeholder={t('Confirm Password')}
                    value={retypePassword}
                    onChange={(e: any) => setRetypePassword(e.target.value)}
                  />
                  <span
                    className='cursor-pointer'
                    style={{ position: 'absolute', top: '25%', right: '20px' }}
                    title={retypePasswordDisplay == true ? 'Hide' : 'Show'}
                    onClick={() => setRetypePasswordDisplay(!retypePasswordDisplay)}
                  >
                    <FontAwesomeIcon icon={retypePasswordDisplay == true ? faEyeSlash : faEye} />
                  </span>
                  <div className='fv-plugins-message-container invalid-feedback'>
                    {error.retypePasswordError || ''}
                  </div>
                </div>

                {/* <!--end::Col--> */}
              </div>
              {/* <!--end::Input group--> */}

              {/* <!--begin::Actions--> */}
              <div className='card-footer d-flex  py-6 px-9'>
                <button
                  type='button'
                  name='submit'
                  className='btn btn-success monthBtn apac-grad'
                  id=''
                  disabled={disable}
                  onClick={() => validation()}
                >
                  {t('Change Password')}
                </button>
              </div>
              {/* <!--end::Actions--> */}
            </form>
            {/* <!-- End form --> */}
          </div>
        </Modal.Body>
      </Modal>
    )
  }

  const changeStatus = async (userId: any, status: any) => {
    const tmpAdmin3 = sessionStorage.getItem('admin')
    const adminIdVal3 = tmpAdmin3 ? JSON.parse(tmpAdmin3)?.adminId ?? '' : ''
    var param: any = {
      userId: userId,
      status: status == true ? 1 : 0,
      adminId: adminIdVal3,
    }

    var res = await fetchData('admin/userStatus', param)
    if (res.status == '200') {
      status == '0'
        ? toastsuccessmsg('Unblock Successfully')
        : toastsuccessmsg('Block Successfully')
      userListApiCall()
    } else {
      toasterrormsg(res.message)
    }
  }

  // Define your DataTable columns

  var usercolumn = useMemo(
    () => [
      {
        name: t('Name'),
        cell: (row: any) => (
          <div
            className='my-3 d-flex align-items-center cursor-pointer'
            onClick={() => {
              if (menuIdEdit) {
                setShowPopup(true)
                setUserId(row.userId)
              }
            }}
          >
            <div className='me-2'>
              <img className='rounded-circle h-30px w-30px' src={row.profile} alt='' />
            </div>
            {row.fullName}
          </div>
        ),
        selector: (row: any) => row.fullName,
        sortable: true,
        filter: true,
        width: '180px',
      },
      {
        name: t('Gender'),
        cell: (row: any) => <div className='my-3'>{row.gender != '' ? row.gender : '-'}</div>,
        selector: (row: any) => row.gender,
        sortable: true,
        filter: true,
        width: '100px',
      },
      {
        name: t('Email'),
        cell: (row: any) => <div className='my-3'>{row.email != '' ? row.email : '-'}</div>,
        selector: (row: any) => row.email,
        sortable: true,
        filter: true,
        width: '220px',
      },
      {
        name: t('Mobile Number'),
        cell: (row: any) => (
          <div className='my-3'>{row.mobileNumber != '' ? row.mobileNumber : '-'}</div>
        ),
        selector: (row: any) => row.mobileNumber,
        sortable: true,
        filter: true,
        width: '180px',
      },
      {
        name: t('Badge'),
        cell: (row: any) => <div className='my-3'>{row.badges != '' ? row.badges : '-'}</div>,
        selector: (row: any) => row.badges,
        sortable: true,
        filter: true,
        width: '180px',
      },
      {
        name: t('Level'),
        cell: (row: any) => <div className='my-3'>{row.level != '' ? row.level : '-'}</div>,
        selector: (row: any) => row.level,
        sortable: true,
        filter: true,
        width: '180px',
      },

      {
        name: t('Language'),
        cell: (row: any) => (
          <div className='my-3'>
            {row.language == 'en'
              ? 'English'
              : row.language == 'ru'
                ? 'Русский'
                : row.language == 'uz'
                  ? 'O’zbekcha'
                  : 'O’zbekcha'}
          </div>
        ),
        sortable: true,
        selector: (row: any) => row.language,
        filter: true,
        width: '140px',
      },
      {
        name: t('Status'),
        cell: (row: any) => (
          <div className='my-3'>
            <label className='form-check form-switch form-check-custom form-check-success form-check-solid '>
              <input
                className='form-check-input cursor-pointer'
                type='checkbox'
                value='1'
                title={row.status == 0 ? 'Active' : 'Inactive'}
                checked={row.status == 0 ? true : false}
                onChange={() => changeStatus(row.userId, !row.status)}
              />
            </label>
          </div>
        ),
        sortable: false,
        filter: false,
        width: '100px',
      },

      {
        name: t('Action'),
        cell: (row: any) => (
          <>
            {menuIdEdit ? (
              <Link
                to={getEncryptedRoute('../explore/user/', { menuId: postManagementId, userId: row.userId })}
                state={{ hotelId: row.hotelId, vendorId: row.vendorId }}
                className='btn btn-sm btn-icon btn-color-success btn-active-light-success'
                title='Explore Posts'
              >
                <KTIcon iconName='picture' className='fs-2' />
              </Link>
            ) : (
              ''
            )}


          </>
        ),
        width: '140px',
      },
    ],
    [t]
  )

  useEffect(() => {
    document.title = 'Insayr | User'

    userListApiCall()
  }, [])

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }

    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='row d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 col-lg-4'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search User')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex justify-content-end col-xl-8 ' data-kt-user-table-toolbar='base'>
          {menuIdAdd ? (
            <button
              type='button'
              className='btn btn-success monthBtn'
              onClick={() => setShowPopup(true)}
            >
              <KTIcon iconName='plus' className='fs-2' />
              {t('Add User')}
            </button>
          ) : (
            ''
          )}
          {/* end::Add Department */}
        </div>
      </div>
    )
  }

  const userListApiCall = async () => {
    var param: any = {}

    var response: any = await fetchData('admin/userList', param)

    if (response.status == '200') {
      let tmpData = response.data.map((items: any) => {
        return {
          ...items,
          profile:
            items.profile != '' ? response.url + items.profile : response.url + 'default.png',
        }
      })

      setUserList(tmpData)
      setorguserList(tmpData)
      setUrl(response.url)
    } else {
      toasterrormsg(response.message)
    }
  }

  const usersearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setUserList(orguserList)
    } else {
      var tmp: any = orguserList.filter((item: any) => {
        var mobile: any = item.mobileNumber
        if (mobile != null && item.mobile != '') {
        }

        return (
          (item.fullName != null &&
            item.fullName != '' &&
            item.fullName.toLowerCase() == text.toLowerCase()) ||
          (item.fullName != null &&
            item.fullName != '' &&
            item.fullName.toLowerCase().includes(text.toLowerCase())) ||
          (item.email != null &&
            item.email != '' &&
            item.email.toLowerCase() == text.toLowerCase()) ||
          (item.email != null &&
            item.email != '' &&
            item.email.toLowerCase().includes(text.toLowerCase())) ||
          (item.location != null &&
            item.location != '' &&
            item.location.toLowerCase() == text.toLowerCase()) ||
          (item.location != null &&
            item.location != '' &&
            item.location.toLowerCase().includes(text.toLowerCase()))
        )
      })

      setUserList(tmp)
    }
  }

  return (
    <>
      <ToastContainer />
      <div className='container-fluid'>
        <div className='row mt-5'>
          <div className='col-12'>
            {orguserList.length > 0 ? (
              <>
                <DataTable
                  columns={usercolumn}
                  data={userList}
                  pagination
                  paginationServer={false}
                  subHeader={true}
                  subHeaderComponent={
                    <CustomHeader search={searchTerm} isfoc={focus} customSearch={usersearch} />
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: t('Rows Per Page'),
                  }}
                />
              </>
            ) : (
              <>
                <div className='text-center px-4'>
                  <div className='d-flex justify-content-center align-items-center flex-column my-10 py-20'>
                    <h2 className='fs-2x fw-bold mb-10'>{t('Welcome To User')}</h2>
                  </div>
                  <p className='text-gray-400 fs-4 fw-semibold mb-10'>{t('There are no User')}</p>
                  {menuIdAdd ? (
                    <Link
                      to='#'
                      className='btn btn-success monthBtn'
                      onClick={() => setShowPopup(true)}
                    >
                      {t('Add User')}
                    </Link>
                  ) : (
                    ''
                  )}
                  <br />
                </div>
                <div className='d-flex justify-content-center'>
                  <img
                    className='mw-100 mh-300px'
                    alt=''
                    src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {showPopup && (
          <Popup
            show={showPopup}
            lang={lang}
            onHide={() => {
              setShowPopup(false)
              setUserId(0)
              userListApiCall()
            }}
            userId={userId}
            menuIdDelete={menuIdDelete}
            url={url}
          />
        )}
        {changePassword && (
          <ChangePasswordPopup
            show={changePassword}
            onHide={() => {
              setChangePassword(false)
              setUserId(0)
            }}
            userId={userId}
          />
        )}
      </div>
    </>
  )
}

export default UserPage
